import {UiItemState,SetItemAction} from '../types/types'
import {uiItemNames, actionTypes, revMode} from '../types/enums'

const initialUiItemState:UiItemState = {
    [uiItemNames.infoContainerItems]: "{\"Message\":\"\"}",  
    [uiItemNames.documentList]: [],
    [uiItemNames.statusCodes]: [],
    [uiItemNames.newMetaItemValues]: [],
    [uiItemNames.revisionCodeValues]: [],
    [uiItemNames.archiveDefinition]: null,
    [uiItemNames.errorMsgVisible]: false,
    [uiItemNames.revToUpdate]: revMode.LATEST_REV ,   
    [uiItemNames.levelToUpdate]: true,
    [uiItemNames.MetaItemPresentations]: null,
    [uiItemNames.MetaItemValidValues]: [],
    [uiItemNames.errorMessage]: {},
    [uiItemNames.DPI]: 600,
  };


export const uiItems = (state: UiItemState = initialUiItemState, action:SetItemAction):UiItemState => {
    const { type, payload } = action;
    switch (type) {
        case actionTypes.SET_ITEMS:
            switch (payload.items) {
                case uiItemNames.dummy:
                    //apend to state
                    return {...state,
                        [payload.items] : [
                                ...state[payload.items],
                                payload.value
                            ]
                        }
                case uiItemNames.statusCodes:
                    //need only listItems
                    return {
                        ...state, // copy the state (level 0)
                        [payload.items]: payload.value.ListItems
                        }
                case uiItemNames.documentListUpdate:
                //change one item
                //console.log("documentListUpdate", payload )
                return {
                        ...state, // copy the state (level 0)
                        documentList: [
                            ...state.documentList.map(item=> {
                                //console.log(item.DocId, payload.value.DocumentID,item.DocId === payload.value.DocumentID,payload.value.Rev)
                                // Find the item with the matching id
                                if(item.DocId === payload.value.DocumentID) {
                                    //console.log("Item found update RevisionToUpdate")
                                    // Return a new object
                                    return {
                                        ...item,  // copy the existing item
                                        //CurrentRevision: payload.value.Rev  // replace with new val
                                        //RevisionToUpdate: payload.value.Rev  // replace with new val
                                        [payload.value.Attribute]: payload.value.Value
                                        }
                                } 
                                // Leave every other item unchanged
                                return item;
                                })
                            ]
                    }    
                case uiItemNames.documentListFileUpdate:
                    //change one item
                    //console.log("documentListFileUpdate", payload )
                    return {
                            ...state, // copy the state (level 0)
                            documentList: [
                                ...state.documentList.map(item=> {
                                    //documentListInStore.filter(x=> x.RevisionToUpdate.Files.filter(y=>y.Name ===meta.DocumentID).length>0)[0].RevisionToUpdate.Files.filter(y=>y.Name ===meta.DocumentID)[0]
                                    //console.log(item,item.DocId, payload.value.DocumentID, payload.value.DocumentID === item.RevisionToUpdate.Files.filter(y=>y.Name === payload.value.DocumentID)[0])
                                    // Find the item with the matching id
                                    if(item.RevisionToUpdate.Files.filter(y=>y.Name === payload.value.DocumentID).length>0)
                                    {
                                        if(payload.value.DocumentID === item.RevisionToUpdate.Files.filter(y=>y.Name === payload.value.DocumentID)[0].Name) {
                                            //console.log("Item found update This document files")
                                            // Return a new object
                                            return {
                                                    ...item,  // copy the existing item
                                                    RevisionToUpdate: {
                                                        ...item.RevisionToUpdate,
                                                        Files: item.RevisionToUpdate.Files.map(file => {
                                                            if(payload.value.DocumentID === file.Name)
                                                            {
                                                                return payload.value.Value
                                                            }
                                                            else
                                                            return file
                                                        })
                                                    }
                                                }
                                        }
                                    } 
                                    return item;
                                    })
                                ]
                        }                        
                case uiItemNames.newMetaItemValues:
                    //console.log("newMetaItemValues check",
                    //payload.value.DocumentID,
                    //state.newMetaItemValues.filter(x=> x.DocumentID === payload.value.DocumentID),
                    //state.newMetaItemValues.filter(x=> x.DocumentID === payload.value.DocumentID).length,
                    //state.newMetaItemValues.filter(x=> x.DocumentID === payload.value.DocumentID).length===0) 
                    
                    if(state.newMetaItemValues.filter(x=> x.DocumentID === payload.value.DocumentID).length===0)
                    {
                        //console.log("newMetaItemValuesStatus APPEND", payload )
                        //append
                        return {...state,
                            [payload.items] : [
                                    ...state[payload.items],
                                    {DocumentID: payload.value.DocumentID, [payload.value.Attribute]: payload.value.Value} as unknown as any
                                    //payload.value
                                ]
                            }
                    } 
                    else
                    {
                        //console.log("newMetaItemValuesStatus CHANGE", payload )
                        return {
                            ...state, // copy the state (level 0)
                            newMetaItemValues: [
                                ...state.newMetaItemValues.map(item=> {
                                    if(item.DocumentID === payload.value.DocumentID) {
                                        // Return a new object
                                        return {
                                        ...item,  // copy the existing item
                                        //Status: payload.value.Status  // replace with new val
                                        [payload.value.Attribute]: payload.value.Value
                                        }
                                    } 
                                    // Leave every other item unchanged
                                    return item;
                                    })
                                ]
                        }
                    }    
                case uiItemNames.MetaItemValidValues:
                    //console.log("MetaItemValidValues", payload )
                    return {
                        ...state, // copy the state (level 0)
                        [payload.items]: [...state.MetaItemValidValues].concat(payload.value.ListItems)
                        }
                default:
                    //console.log("Default action fired")
                    return {
                        ...state, // copy the state (level 0)
                        [payload.items]: payload.value
                        }
            }    
        case actionTypes.CLEAR_ITEMS:
            return Object.assign({}, state, {
                //set to initial state
                [payload.items]: initialUiItemState[payload.items],
            });
        default:
            return state;
    }
}